import React, {useState, useEffect, useContext} from "react"

// config, context & data
import {ShopContext} from "../../../../context/ShopContext"
import data from "../../../../data"

// controls, subviews
import {Button, Money} from "../../../controls"
//import Options from "./Customize/CustomizeOptions"
//import Subactivities from "./Customize/CustomizeSubactivities"
import Benefits from "./Customize/CustomizeBenefits"
import Participants from "./Customize/CustomizeParticipants"
import Regions from "./Customize/CustomizeRegion"
import CustomizeOptions from "./Customize/Customize.Options";

// styling
import "./Customize.scss"

// the component
function Customize({activity, close, cancel}) {
  // context
  const shop = useContext(ShopContext)

  // state
  const [state, setState] = useState({
    regionCode: null, 
    options: [], 
    subactivities: [], 
    participantCount: null,
    isAlreadyInCart: false
  })
  const [price, setPrice] = useState(0)
  
  // set defaults
  useEffect(() => {
    // TODO all this should really be inside business logic, and not here
    // attempt to get from cart
    let adventureActivity = data.Cart.getAdventureActivity(activity._id)
  
    if(adventureActivity) {
      // gather values
      const regionCode = adventureActivity.RegionCode 
      const participantCount = adventureActivity.ParticipantCount 
      const options = adventureActivity.Options.map(aao => {
        return {id:aao.ID, count:aao.UnitCount}
      })
      const subactivities = adventureActivity.Subactivities
      const isAlreadyInCart = true 

      // update state
      setState({regionCode, participantCount, options, subactivities, isAlreadyInCart})
    }
    else {
      // region code
      let regionCode = null
      let adventureRegion = data.Cart.getAdventureRegion() // already have an adventure region, try to use that?
      if(adventureRegion) {
        // we can only use this if the activity has that region available
        if((activity.regions || []).includes(adventureRegion.code)) {
          regionCode = adventureRegion.code
        }
      }
      // still no default region code ... use the activity's default
      if(!regionCode) {
        regionCode = data.Activity.getDefaultRegionCode(activity)
      }

      // participant count
      let participantCount = data.Activity.getDefaultParticipantCount(activity._id, regionCode) 
      // if the adventure's participant count (highest amongst all acitivities in cart) is possible, we select that one
      let adventureParticipantCount = data.Cart.getAdventureParticipantCount() 
      if((adventureParticipantCount || 0) > 0) {
        let possibleParticipants = data.Activity.getPriceConfigurations(activity, regionCode).map(pc => pc.participantCount)
        if(possibleParticipants.includes(adventureParticipantCount)) {
          participantCount = adventureParticipantCount
        }
      }

      // other values
      const options = []
      const subactivities = data.Activity.getSubactivities(activity, regionCode, participantCount, false)
      const isAlreadyInCart = false

      // update state
      setState({regionCode, participantCount, options, subactivities, isAlreadyInCart})
    }

  }, [activity])

  // update the activity total
  useEffect(() => {
    if(activity && state.regionCode && state.participantCount && state.options && state.subactivities) {
      let calculatedPrice = data.Activity.getPrice(activity, state.regionCode, state.participantCount, state.options, state.subactivities) 
      setPrice(calculatedPrice)
    }
  }, [activity, state.regionCode, state.participantCount, state.options, state.subactivities])

  // change the region
  const changeRegion = (regionCode) => {
    const participantCount = data.Activity.getDefaultParticipantCount(activity._id, regionCode)
    const options = []
    const subactivities = data.Activity.getSubactivities(activity, regionCode, participantCount, false)
    setState({...state, regionCode, participantCount, options, subactivities})
  }

  // change the participant count
  const changeParticipantCount = (participantCount) => {
    const subactivities = data.Activity.getSubactivities(activity, state.regionCode, participantCount, false)
    setState({...state, participantCount, subactivities})
  } 

  // change subactivities
  const changeSubactivities = (subactivities) => {
    setState({...state, subactivities})
  }

  // change options
  const changeOptions = (options) => {
    setState({...state, options})
  }

  // render
  let actions = (
    <div className="customize-actions">
      <Button
        label="zurück"
        kind="ok-secondary" 
        onClick={() => cancel() } 
      />
      <Button 
        label={state.isAlreadyInCart ? "Änderungen übernehmen" : "in den Warenkorb"}
        onClick={() => {
          shop.cart.addActivity(activity, state.regionCode, state.options, state.participantCount, state.subactivities)
          close()
        }}
      />
    </div>
  )

  // home delivery activities cannot be combined with others
  const cannotAddHomeDelivery = (activity.isHomeDelivery && shop.cartActivities.length > 0 && state.isAlreadyInCart === false)
  const cannotAddToHomeDelivery = (shop.cartActivities.some(a => a.IsHomeDelivery) && state.isAlreadyInCart === false)
  // online events cannot be combined with others
  const cannotAddOnlineEvent = (activity.isOnlineEvent && shop.cartActivities.length > 0 && state.isAlreadyInCart === false)
  const cannotAddToOnlineEvent = (shop.cartActivities.some(a => a.IsOnlineEvent) && state.isAlreadyInCart === false)
  // combination not possible?
  if(cannotAddHomeDelivery || cannotAddToHomeDelivery || cannotAddOnlineEvent || cannotAddToOnlineEvent) {
    let cannotAddText 
    if(cannotAddHomeDelivery || cannotAddToHomeDelivery) {
      if(cannotAddHomeDelivery) {
        cannotAddText = "Dies ist eine Überraschung, die direkt nach Hause geliefert wird. Sie kann nicht mit anderen Aktivitäten kombiniert werden."
      }
      else {
        cannotAddText = "Im Warenkorb befindet sich eine Überraschung, die direkt nach Hause geliefert wird. Sie kann nicht mit anderen Aktivitäten kombiniert werden."
      }
    }
    else {
      if(cannotAddOnlineEvent) {
        cannotAddText = "Dies ist eine Überraschung, die online statt findet. Sie kann nicht mit anderen Aktivitäten kombiniert werden."
      }
      else {
        cannotAddText = "Im Warenkorb befindet sich eine Überraschung, die online statt findet. Sie kann nicht mit anderen Aktivitäten kombiniert werden."
      }
    }
    actions = (
      <div className="customize-actions-impossible">
        <div  className="customize-actions-impossible-text">
          <p>
            {cannotAddText}
          </p>
        </div>
        <Button
          label="zurück"
          kind="ok-secondary" 
          onClick={() => cancel() } 
        />
      </div>
    )
  }

  return (
    <div id="v-activity-customize">
      <h1>{activity.title}</h1>
      <Benefits activity={activity} regionCode={state.regionCode} />
      <Regions activity={activity} regionCode={state.regionCode} onChange={changeRegion} />
      <Participants activity={activity} regionCode={state.regionCode} participantCount={state.participantCount} onChange={changeParticipantCount} />
      <CustomizeOptions 
        activity={activity} 
        regionCode={state.regionCode} 
        participantCount={state.participantCount} 
        options={state.options}
        subactivities={state.subactivities} 
        onChangeOptions={changeOptions}
        onChangeSubactivities={changeSubactivities} 
      />
      {/* 
      <div className="customize-options">
        <h2>Optionen</h2>
        <Subactivities activity={activity} regionCode={state.regionCode} participantCount={state.participantCount} subactivities={state.subactivities} onChange={changeSubactivities} />
        <Options activity={activity} regionCode={state.regionCode} options={state.options} participantCount={state.participantCount} onChange={changeOptions} />
      </div>
      */}
      <div className="customize-price">
        <h2>Summe</h2>
        <Money amount={price} displayVatInfo={true} total />
      </div>
      {actions}
      <div className="customize-close" onClick={() => cancel() } ><span>×</span></div>
    </div>
  )
}

export default Customize